import React, {useState} from 'react';
import './button.css';
import Translate from "../localization/Translate";

export default function (props) {
    let [open, setOpen] = useState(false);
    let messageBox;
    if(open) {
        messageBox = <div
            style={{
                position: "absolute",
                border: "0.07rem solid black",
                padding: "0.71rem",
                right: " 3.43rem",
                top: "2.86rem",
                backgroundColor: "#fff",
                fontSize: "1.14rem"
            }}>
            <Translate id={props.message}/>
        </div>;
    }
    return (
        <div>
            <div onClick={(event) => {
                event.stopPropagation();
                setOpen(!open);
            }} style={{
                float: "right",
                marginRight: "1.43rem"
            }}>
                <div style={{
                    color: "#da9a69",
                    border: "0.07rem solid #da9a69",
                    borderRadius: "2.14rem",
                    width: "2.14rem",
                    padding: "0.29rem",
                    fontSize: "1.14rem",
                    boxSizing: "border-box",
                    textAlign: "center"
                }}>!</div>
            </div>
            { messageBox }
        </div>
    );
}